import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface categoriesState {
  selectedCategories: number[]
}

const initialState: categoriesState = {
  selectedCategories: [],
}

export const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    addSelectedCategories(state, action: PayloadAction<number>) {
      state.selectedCategories.push(action.payload)
    },
    removeSelectedCategories(state, action: PayloadAction<number>) {
      state.selectedCategories = state.selectedCategories.filter(
        (el) => el !== action.payload
      )
    },
  },
})

export const categoriesActions = categoriesSlice.actions
export const categoriesReducer = categoriesSlice.reducer
